<script lang="ts">
  import { storyblokEditable } from '$lib/actions/storyblok-editable';
  import { cn } from '$lib/utils';
  import { getUUID } from '$lib/utils/uuid';
  import type { CenteredTextSectionStoryblok } from '$types/bloks';
  import ImageRow from './marketing-sub-blocks/image-row.svelte';
  import ProductsGrid from './marketing-sub-blocks/products-grid.svelte';
  import Text from './marketing-sub-blocks/text.svelte';
  import VariantsComparison from './marketing-sub-blocks/variants-comparison.svelte';
  import Video from './marketing-sub-blocks/video.svelte';

  export let block: CenteredTextSectionStoryblok;
</script>

<section use:storyblokEditable={block} class="px-2 lg:px-8 !py-0">
  <div class="container mx-auto">
    {#if block.text?.[0]}
      <div class="flex justify-center">
        <Text
          block={block.text?.[0]}
          class={cn(
            'lg:py-[88px] px-2 pt-[88px] pb-2 max-w-2xl',
            block.rows[0].component === 'variants-comparison' && 'pb-0 lg:pb-0'
          )}
        />
      </div>
    {/if}

    <div class="mt-8 lg:mt-0 py-2 lg:py-8 space-y-2 lg:space-y-4">
      {#each block.rows as row}
        {#if row.component === 'image-row'}
          <ImageRow {row} />
        {:else if row.component === 'products-row'}
          <div use:storyblokEditable={row} class="[&>*]:py-0">
            <ProductsGrid
              content={{
                _uid: getUUID(),
                component: 'products-grid',
                products: row.products,
                highlight_first: false
              }}
            />
          </div>
        {:else if row.component === 'video'}
          <div use:storyblokEditable={row} class="[&>*]:py-0">
            <Video content={row} />
          </div>
        {:else if row.component === 'variants-comparison'}
          <VariantsComparison content={row} />
        {/if}
      {/each}
    </div>
  </div>
</section>
